// sub pages
import AccountPage from './AccountPage';

export default AccountPage;



// WEBPACK FOOTER //
// ./src/pages/account/index.jsx